import { lazy } from "react";
import { createBrowserRouter, Navigate, useParams } from "react-router-dom";
import { AdminLayout } from "./layout/admin-layout";

const DashboardPage = lazy(() => import("@/pages/dashboard/dashboard-page"));
const SongsWorkbenchPage = lazy(() => import("@/pages/songs/songs-list-page"));
const UsersWorkbenchPage = lazy(() => import("@/pages/users/users-workbench-page"));
const DiagnosticsPage = lazy(() => import("@/pages/diagnostics/diagnostics-page-v2"));
const SeedPage = lazy(() => import("@/pages/seed/seed-page"));
const BriefsWorkbenchPage = lazy(() => import("@/pages/briefs/briefs-workbench-page"));
const SoundscorePage = lazy(() => import("@/pages/soundscore/soundscore-page"));
const FeedbackWorkbenchPage = lazy(() => import("@/pages/feedback/feedback-workbench-page"));
const CatalogPage = lazy(() => import("@/pages/catalog/catalog-page"));
const ErrorsPage = lazy(() => import("@/pages/errors/errors-page"));
const BillingPage = lazy(() => import("@/pages/billing/billing-page"));
const AvaPage = lazy(() => import("@/pages/ava/ava-page"));
const JobsPage = lazy(() => import("@/pages/jobs/jobs-page"));
const ReportsWorkbenchPage = lazy(() => import("@/pages/reports/reports-workbench-page"));
const SystemAssetsPage = lazy(() => import("@/pages/system-assets/system-assets-page"));

function SongDetailRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/songs?id=${id}`} replace />;
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "songs", element: <SongsWorkbenchPage /> },
      { path: "songs/:id", element: <SongDetailRedirect /> },
      { path: "users", element: <UsersWorkbenchPage /> },
      { path: "diagnostics", element: <DiagnosticsPage /> },
      { path: "briefs", element: <BriefsWorkbenchPage /> },
      { path: "soundscore", element: <SoundscorePage /> },
      { path: "feedback", element: <FeedbackWorkbenchPage /> },
      { path: "catalog", element: <CatalogPage /> },
      { path: "billing", element: <BillingPage /> },
      { path: "errors", element: <ErrorsPage /> },
      { path: "ava", element: <AvaPage /> },
      { path: "seed", element: <SeedPage /> },
      { path: "jobs", element: <JobsPage /> },
      { path: "reports", element: <ReportsWorkbenchPage /> },
      { path: "system-assets", element: <SystemAssetsPage /> },
    ],
  },
]);
